var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-2018-wrap"},[_c('YTop'),_vm._v(" "),_c('header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('footer',[_vm._v("本活动最终解释权归一富财经所有")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }